(() => {
  const revealClass = 'homepage-scroll-reveal';
  const visibleClass = 'is-visible';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const observer = 'IntersectionObserver' in window && !reducedMotion.matches
    ? new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add(visibleClass);
          currentObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -9% 0px',
        threshold: 0.12
      })
    : null;

  const addReveal = (element, delay = 0) => {
    if (!element || element.classList.contains(revealClass)) return;

    element.classList.add(revealClass);
    element.style.setProperty('--homepage-reveal-delay', `${delay}ms`);

    if (observer) {
      observer.observe(element);
    } else {
      element.classList.add(visibleClass);
    }
  };

  const addAll = (root, selector, stagger = 0, startDelay = 0) => {
    root.querySelectorAll(selector).forEach((element, index) => {
      addReveal(element, startDelay + (index * stagger));
    });
  };

  const prepareHomepageSections = (scope = document) => {
    addAll(scope, '.homepage-hub__title');
    scope.querySelectorAll('.homepage-hub__advantage').forEach((card, index) => {
      addReveal(card.querySelector('.homepage-hub__advantage-title'), index * 70);
      addReveal(card.querySelector('.homepage-hub__advantage-text'), 70 + (index * 70));
    });
    addAll(scope, '.homepage-hub__category-content', 90);
    addAll(scope, '.homepage-hub__tabs');

    addAll(scope, '.homepage-tech__header');
    addAll(scope, '.homepage-tech__content', 80, 70);

    addAll(scope, '.homepage-why__header');
    addAll(scope, '.homepage-why__content', 80, 60);

    addAll(scope, '.homepage-latest__header');
    addAll(scope, '.homepage-latest__content', 70, 50);

    addAll(scope, '.homepage-community__header');
    scope.querySelectorAll('.homepage-community__card').forEach((card, index) => {
      addReveal(card.querySelector('.homepage-community__content'), index * 80);
      addReveal(card.querySelector('.homepage-community__actions'), 80 + (index * 80));
    });
  };

  const initialize = () => {
    prepareHomepageSections();
    document.documentElement.classList.add('homepage-scroll-reveal-ready');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    prepareHomepageSections(event.target);
  });
})();
